import React from 'react';
import styles from '../Operations.module.css';

interface MAPAComponent extends React.FC {
  title?: string;
}

/**
 * MOBILEACTIVEPCT - % Mobile App Engaged - Active Customers
 * KPI information component
 */
const MAPA: MAPAComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        % Mobile App Engaged – Active Customers - measures the percent of customers associated with your store that have made a purchase either in-store or online (active shopper) and have used the Ace Hardware mobile app in the past 12 months.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Mobile app engaged customers shop and spend more than non-Mobile app members, and 18% shop online, while only representing 12% of all active members.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        15% mobile app engaged – active customers in the past 12 months
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Execute the Ace App Playbook by completing the following actions:
        <ol>
          <li>
            <strong>Cashier Training:</strong>
            <br />
            Enroll all associates in the six short Ace Rewards training courses to ensure they fully understand the program’s benefits and key components.
          </li>
          <li>
            <strong>Hang Signage:</strong>
            <br />
            Display Ace Rewards signage with QR codes throughout the store to promote enrollment through the Ace mobile app.
          </li>
          <li>
            <strong>Distribute Take-With Collateral:</strong>
            <br />
            Provide Ace Rewards take-with materials at the registers. Instruct cashiers to staple app bag-stuffers to receipts for customers who do not yet have the mobile app, enabling them to download it at their convenience. Ensure app takeaway cards are stocked in the holder and displayed at each register.
          </li>
          <li>
            <strong>Monitor with Reporting:</strong>
            <br />
            Track performance using the Mobile App Download Report available on ADW.  <br /> Navigate to: <br /> AceNet → Analytics Dashboard → Store → Mobile App Download Report
          </li>
        </ol>
      </div>
    </div>
  );
};

MAPA.title = '% Mobile App Engaged - Active Customers - Ace Rewards';
export default MAPA;

